import React, { Component } from 'react';
import { observer, Provider, inject } from 'mobx-react';
import { ExamplesComponent } from './examples.component';
import ExamplesForm from './examples.form';

@inject('appStore', 'routerStore')
@observer
export class ExamplesProvider extends Component {
    form;

    constructor(props) {
        super(props);
        const { appStore, match } = props;

        appStore.setURLProps(match);
        appStore.clearError();

        this.form = new ExamplesForm();
        this.form.setURL(appStore.Link);
        this.form.setStore(appStore);
    }

    render() {
        return (
            <Provider form={this.form}>
                <ExamplesComponent key='examples' />
            </Provider>
        );
    }
}
